<template>
  <div
    :class="{
      'grid-container-fi': true,
      'fi:max-w-xl': stretch,
      'fi:container': container,
      'fi:sm:container fi:sm:max-w-xl': containerSm,
      'fi:md:container fi:md:max-w-xl': containerMd,
      'fi:xl:container fi:xl:max-w-xl': containerXl,
    }"
  >
    <div :class="combinedGridClass">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

defineOptions({
  name: 'GridContainerFi',
});

const props = withDefaults(
  defineProps<{
    container?: boolean;
    containerSm?: boolean;
    containerMd?: boolean;
    containerXl?: boolean;
    stretch?: boolean;
    gridBaseClass?: string;
    gridClass?: string;
    limitNonContainerWidth?: boolean;
  }>(),
  {
    container: true,
    stretch: true,
    gridBaseClass: 'fi:grid-cols-12 fi:gap-small fi:md:gap-large',
    gridClass: '',
  },
);

const combinedGridClass = computed<string>(
  () => `fi:grid ${props.gridBaseClass} ${props.gridClass}`,
);
</script>

<style src="./grid-container-fi" />
